import mhead from 'mhead-js';
$(window).on('load', function() {
	$('.desktop-header').mhead({
		scroll: {
			tolerance: 1
		}
	});
});
